import { render, staticRenderFns } from "./ArticlePagination.vue?vue&type=template&id=20327fc4&"
import script from "./ArticlePagination.vue?vue&type=script&lang=js&"
export * from "./ArticlePagination.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports